<template>
    <custom-modal :title="item.ref_number ? item.ref_number : 'Memo'" v-model="show" @close="close()" :loading="loading" :width="hasFile ? 1600 : 600">
        <v-row dense dir="rtl">
            <v-col cols="12" md="6">
                <div class="dhivehi text-right" dir="rtl">
                    <h2 class="english">{{ item.ref_number }}</h2>
                    <h4 class="mt-1 grey--text text--darken-3">{{ item.title }}</h4>
                    <p class="ma-0 mt-1 grey--text text--darken-2">{{ item.dhivehi_date }}</p>
                    <p class="ma-0 mt-1 grey--text text--darken-2">{{ item.description }}</p>

                    <p class="ma-0 mt-2 grey--text text--darken-3" v-if="item.related_memo">
                        ގުޅުންހުރި މެމޯ: 
                        <strong class="english">
                            <!-- <a :href="item.related_memo.document.file.url" target="_blank">
                                {{item.related_memo.ref_number}}
                            </a> -->
                            <bdi>{{item.related_memo.ref_number}}</bdi>
                        </strong>
                    </p>

                    <v-chip small dark color="primary" class="english text-uppercase mt-2"><strong>{{ item.status }}</strong></v-chip>

                    <v-divider class="mb-3 mt-2"></v-divider>

                    <div v-html="item.text" class="grey--text text--darken-2 text-justified rich-text-content"></div>

                    <v-divider class="mb-3"></v-divider>
                    
                    <v-chip-group column class="dhivehi">
                        <v-chip small v-for="tag in item.tags" :key="tag.slug">
                            <strong>{{ tag.name_div }}</strong>
                        </v-chip>
                    </v-chip-group>
                </div>
            </v-col>

            <v-col cols="12" md="6">
                <!-- <div id="pdf-container" v-if="hasFile"> -->
                <div id="pdf-container" v-if="item.document && item.document.file">
                    <!-- <pre>
                    {{ item.document.file.url}} 
                    </pre> -->
                    <!-- <vue-pdf-app :pdf="item.document.file.url"></vue-pdf-app> -->
                    <view-pdf-modal :modal="false" :pdf_url="item.document.file.url"></view-pdf-modal>
                </div>
            </v-col>
        </v-row>
    </custom-modal>
</template>

<script>
import CustomModal from '../util/CustomModal.vue'
import ViewPdfModal from '../util/ViewPdfModal.vue'
// import VuePdfApp from "vue-pdf-app";
// import "vue-pdf-app/dist/icons/main.css";

export default {
    components: {
        CustomModal, 
        ViewPdfModal
        // VuePdfApp
    },
    data: () => ({
        show: false,
        loading: false,
        item: {},
    }),
    computed: {
        hasFile() {
            return this.item.document && this.item.document.file
        },
    },
    methods: {
        getItem() {
            this.loading = true
            return this.$axios.get(`/api/memos/${this.item.id}`).then(res => {
                this.item = res.data
            }).finally(() => this.loading = false)
        },
        open(id) {
            this.item.id = id
            this.getItem()
            this.show = true
        },
        close() {
            this.$emit('reload')
            this.resetData()
        },
        resetData() {
            Object.assign(this.$data, this.$options.data())
        },
    },
}
</script>

<style scoped>
/* #pdf-container {
    max-height: 65vh !important;
} */

.rich-text-content > p {
    text-align: justify !important;
}

table {
    border: 1px solid grey !important;
    border-collapse: collapse;
}

th {
    border: 1px solid grey !important;
}

td {
    padding: 5px 5px 5px;
    border: 1px solid grey !important;
}

.grey-text {
    color: grey;
}
</style>